import { render, staticRenderFns } from "./investment_b.vue?vue&type=template&id=602e769c&scoped=true"
import script from "./investment_b.vue?vue&type=script&lang=js"
export * from "./investment_b.vue?vue&type=script&lang=js"
import style0 from "./investment_b.vue?vue&type=style&index=0&id=602e769c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602e769c",
  null
  
)

export default component.exports